<template>
  <!-- 如何获得 -->
  <div class="container">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="1" isshow="1"></HeadTab>
    <!-- <img class="opl" src="/static/img/Mask_group.png" alt="" /> -->
    <div class="obtain">
      <div class="obtain_inner">
        <div class="obtain_left">
          <div class="obtain_title">КАК ВЗЯТЬ <span>МИКРОКРЕДИТ?</span></div>
          <div class="obtain_desc">Мы упростили процесс получения микрокредита до минимума. Без лишних справок, очередей и ожидания. Ваше время - наш приоритет.</div>
          <div class="obtain_steps">
            <div class="step_list" v-for="item in stepList" :key="item.step">
              <div class="step_point" :class="item.pointClass">{{ item.step }}</div>
              <div class="step_content">
                <div class="step_title">{{ item.title }}</div>
                <div class="step_text">{{ item.text }}</div>
              </div>
            </div>
          </div>
          <div class="lkc">
            <img class="mnb" style="margin-right: 0.08rem;" src="/static/img/Container5.png" alt="" />
            <img class="mnb" src="/static/img/Container4.png" alt="" />
          </div>
        </div>
        <!-- 额度信息 -->
        <div class="obtain_right">
          <LoanCard :bgindex="2"></LoanCard>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="0"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'

  export default {
    name: 'obtain',
    data() {
      return {
        stepList: [
          {
            step: 1,
            title: 'Заполните анкету',
            text: 'Нажмите кнопку "Личный кабинет" и введите данные вашего удостоверения личности. Нам нужно всего несколько минут вашего времени.',
            pointClass: 'step_point-solid',
            badges: []
          },
          {
            step: 2,
            title: 'Выберите сумму',
            text: 'Используйте калькулятор, чтобы определить комфортный размер займа. Мы работаем честно: никаких скрытых комиссий.',
            pointClass: 'step_point-outline',
            badges: []
          },
          {
            step: 3,
            title: 'Получите деньги',
            text: 'После одобрения средства мгновенно поступят на вашу банковскую карту или текущий счет IBAN. Быстро и надежно.',
            pointClass: 'step_point-dark'
          }
        ]
      }
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>
  .opl {
    width: 3.29rem;
    height: 1.82rem;
    position: absolute;
    top: 0.57rem;
    left: 0;
  }
  .obtain {
    background: #FFF8F6;
    padding: 0.78rem 1.58rem;
  }
  .obtain_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  .obtain_title {
    width: 3.32rem;
    color: #271814;
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.31rem;
    margin-bottom: 0.13rem;
  }
  .obtain_title span {
    color: #B62404;
  }
  .obtain_desc {
    width: 2.92rem;
    font-family: Inter, Inter;
    font-weight: 300;
    font-size: 0.1rem;
    color: #5B403B;
    line-height: 0.17rem;
    margin-bottom: 0.33rem;
  }
  .obtain_steps {
    position: relative;
  }
  .obtain_steps::before {
    content: '';
    position: absolute;
    left: 0.2rem;
    top: 0.3rem;
    bottom: 1rem;
    width: 0.01rem;
    background: #ec6a5d;
  }
  .step_list {
    width: 4.04rem;
    display: flex;
    align-items: flex-start;
    gap: 0.22rem;
    position: relative;
    z-index: 1;
    margin-bottom: 0.34rem;
  }
  .step_list:last-child {
    margin-bottom: 0;
  }
  .step_point {
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.16rem;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
  }
  .step_point-solid {
    background: #FF5836;
  }
  .step_point-outline {
    background: #F9DCD6;
    border: 0.01rem solid #FF5836;
    color: #B62404;
    box-sizing: border-box;
  }
  .step_point-dark {
    background: #590B00;
    color: #ffffff;
  }
  .step_content {
    flex: 1;
  }
  .step_title {
   font-family: Inter, Inter;
   font-weight: normal;
   font-size: 0.16rem;
   color: #271814;
   margin-bottom: 0.08rem;
  }
  .step_text {
    width: 2.2rem;
    color: #5B403B;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.09rem;
    line-height: 0.15rem;
  }
  .lkc{
    padding-left: 0.64rem;
    margin-top: 0.13rem;
  }
  .mnb{
    width: 0.16rem;
    height: 0.16rem;
  }
  .step_badges {
    display: flex;
    align-items: center;
    gap: 0.05rem;
    margin-top: 0.12rem;
  }
  .step_badge {
    height: 0.22rem;
    padding: 0 0.08rem;
    border-radius: 0.11rem;
    background: #ff4f69;
    color: #ffffff;
    font-family: Montserrat;
    font-weight: 700;
    font-size: 0.09rem;
    line-height: 0.22rem;
  }
  .support_panel {
    position: relative;
    min-height: 0.82rem;
    background: rgba(255,88,54,0.2);
    border-radius: 0.16rem;
    padding: 0.17rem;
    box-sizing: border-box;
    overflow: hidden;
  }
  .support_title {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.1rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.02rem;
  }
  .support_text {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 0.07rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.08rem;
  }
  .njc{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .koz{
    width: 0.09rem;
    height: 0.09rem;
    margin-right: 0.04rem;
  }
  .support_phone {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.08rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    position: relative;
    z-index: 1;
  }
  .support_image {
    width: 0.58rem;
    height: 0.58rem;
    position: absolute;
    right: 0;
    bottom: 0;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .obtain_inner {
      gap: 0.3rem;
    }
    .obtain_left,
    .obtain_right,
    .obtain_title,
    .obtain_desc,
    .step_list,
    .step_text {
      width: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl {
      width: 2.29rem;
      height: 1.32rem;
      top: 0.95rem;
    }
    .obtain {
      padding: 0.42rem 0.2rem 0.48rem;
    }
    .obtain_inner {
      flex-direction: column;
    }
    .obtain_left,
    .obtain_right {
      width: 100%;
    }
    .obtain_title {
      font-size: 0.28rem;
      line-height: 0.35rem;
    }
    .obtain_desc {
      font-size: 0.12rem;
      line-height: 0.2rem;
      margin-bottom: 0.24rem;
    }
    .obtain_steps::before {
      left: 0.18rem;
    }
    .step_list {
      gap: 0.16rem;
      margin-bottom: 0.24rem;
    }
    .step_point {
      width: 0.48rem;
      height: 0.48rem;
      font-size: 0.18rem;
    }
    .step_title {
      font-size: 0.15rem;
      margin-bottom: 0.08rem;
    }
    .step_text {
      font-size: 0.1rem;
      line-height: 0.17rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/obtain.vue